import { useTenant } from '@/hooks/useTenant';

interface CompanySettings {
  enableExtendedProjects: boolean;
}

export function useCompanySettings(): CompanySettings & { isLoading: boolean } {
  const { company, isLoadingCompany } = useTenant();

  return {
    enableExtendedProjects: company?.enable_extended_projects ?? false,
    isLoading: isLoadingCompany,
  };
}
